module.exports = __webpack_public_path__ + "img/p13.89b76cd3.png";